export default __webpack_public_path__ + "static/media/dutchgot-screenshot-03.7a51b549.png";